import {
  OperatorSettingsCurrencyState,
  OperatorSettingsGeneralState,
  OperatorSettingsState,
} from './operator-settings-state.model';

export const INITIAL_SETTINGS_STATE: OperatorSettingsGeneralState = {
  settings: [],
  loadState: 'idle',
  error: null,
};

export const INITIAL_CURRENCY_STATE: OperatorSettingsCurrencyState = {
  currencies: [],
  loadState: 'idle',
  error: null,
};

export const INITIAL_OPERATOR_SETTINGS_STATE: OperatorSettingsState = {
  operatorSettings: INITIAL_SETTINGS_STATE,
  currency: INITIAL_CURRENCY_STATE,
};
